import React from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';
import { CloseButtonWrapper } from 'features/menu/components/product-detail/product-detail-flow/product-detail-close/styled';

import { t } from 'state/intl/translations';

interface IProductDetailClose {
  onDismiss: () => void;
}

export const ProductDetailClose: React.FC<IProductDetailClose> = ({ onDismiss }) => {
  return (
    <CloseButtonWrapper>
      <Pressable onPress={onDismiss} accessibilityRole="button" accessibilityLabel={t('close')}>
        <Icon variant="cancel" />
      </Pressable>
    </CloseButtonWrapper>
  );
};
